import { getEnv, getUrlParam } from '../utils/utils.js'

export function HandleSensors(res) {
  try {
    const currentEnv = getEnv()
    const IsPord = currentEnv == 'prod' || currentEnv == 'pre'
    window.VZAN_SHENCE = window['sensorsDataAnalytic201505']
    window.VZAN_SHENCE.init({
      server_url: `https://datasink.vzan.com/sa?project=${
        IsPord ? 'production' : 'default'
      }`,
      heatmap: {
        scroll_notice_map: 'not_collect',
        clickmap: 'default',
      },
      show_log:
        ((window.localStorage &&
          window.localStorage.getItem('shence_show_log')) ||
          '0') === '1',
      is_track_single_page: true,
      app_js_bridge: true,
      send_type: 'beacon',
    })
    const data = res ? res.live : window.zbvd
    if (data) {
      RegisterPage(data)
    }
    window.VZAN_SHENCE.quick('autoTrack', {
      platform: '直播-用户-H5端',
    })
    window.VZAN_SHENCE.use('PageLeave')
  } catch (error) {
    console.log(error)
  }
}

// 设置用户信息
export function SetUserProfile(loginuser) {
  window.VZAN_SHENCE.setProfile({
    uid: loginuser.uid,
    userid: loginuser.uc_id,
    user_nickname: loginuser.nickname || '',
    user_gender: loginuser.sex || '未知',
  })
  let sensorCookie = window.$.cookie('sensorsdata2015jssdkcross')
  if (sensorCookie) {
    sensorCookie = JSON.parse(sensorCookie) || {}
    const uc_id = window.userInfo.userCenterId
    if (sensorCookie.distinct_id !== uc_id) {
      window.VZAN_SHENCE.login(uc_id)
    }
  }
}

// 注册【直播间】公共属性
export function RegisterPage(res) {
  window.VZAN_SHENCE.registerPage({
    zb_id: Number(res.zbid || getUrlParam('zbid') || window.zbvd.zbid), // 直播间ID
    zb_name: res.liveroomname || window.zbvd.name, // 名称
    zb_live_id: Number(res.topicid || getUrlParam('ztpid') || window.zbvd.tpid), // 直播ID
    zb_live_name: res.topictitle || window.zbvd.liveroomname || '', // 直播名称
    zb_live_state: res.zb_live_state || 0, // 直播状态
    zb_live_type: res.zb_live_type || window.zbvd.customerType, // 直播类型
    platform: '直播-用户-H5端', // 项目名称
  })
}

// 神策统计配置
export function SetSensorsData(res) {
  HandleSensors(res)
  SetUserProfile(res.loginuser)
}

// 提交神策统计事件
export function SensorsPost(data) {
  window.VZAN_SHENCE &&
    window.VZAN_SHENCE.track(data.eventName, {
      is_success: data.isok,
      fail_reason: data.isok ? '' : data.Msg,
      zb_discussion_id: data.zb_discussion_id,
    })
}

// 神策自定义统计事件
export function SensorsAutoPost(eventName, data) {
  window.VZAN_SHENCE &&
    window.VZAN_SHENCE.track(eventName, {
      ...data,
    })
}

// 卡特点击埋点
export function PostKateClickData(data = {}) {
  // if (window.zbvd.customLive !== 'KA_TE') {
  //   return false
  // }
  // 买点信息
  const payload = Object.assign(
    {
      btn: '',
      zbuser_id: 0,
      nickname: '',
      avatar: '',
      parent_id: 0,
      parent_name: '',
      parent_link: window.location.href,
      target_id: 0,
      target_name: '',
      target_link: '',
      target_type: 0,
      parent_type: 0,
      keyword: '',
    },
    data
  )
  // 提交埋点
  SensorsAutoPost('click_kate', payload)
  console.log('已提交埋点', payload)
}
